import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DatasourceTableUIModel } from '../datasource-table/datasource-table.model';
import { DatasourceListViewData, DatasourceStoreModel, DatasourceUIModel } from './datasource.model';
import { DatasourceQuery } from './datasource.query';

export interface DatasourceTableDictionary {
  [path: DatasourceTableUIModel['$path']]: DatasourceTableContext;
}

export interface DatasourceTableContext {
  table: DatasourceTableUIModel;
  datasource: DatasourceUIModel;
}

@Injectable()
export abstract class AllDatasourcesQuery implements Partial<Omit<DatasourceQuery, 'selectAll'>> {
  abstract readonly loading$: Observable<boolean>;
  abstract readonly listItems$: Observable<DatasourceListViewData[]>;
  abstract readonly items$: Observable<DatasourceUIModel[]>;
  abstract readonly datasourceTableDictionary$: Observable<DatasourceTableDictionary>;

  abstract selectAll(): Observable<DatasourceStoreModel[]>;
  abstract getEntity(datasourceId: string): DatasourceStoreModel | undefined;
  abstract getUIEntity(datasourceId: string): DatasourceUIModel | undefined;
  abstract selectUIEntity(datasourceId: string): Observable<DatasourceUIModel | undefined>;
  abstract getActiveUIModel(): DatasourceUIModel | undefined;
}
